/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_DatasourcesInputs */

const en_page_title_datasources = /** @type {(inputs: Page_Title_DatasourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data sources`)
};

const nl_page_title_datasources = /** @type {(inputs: Page_Title_DatasourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Databronnen`)
};

/**
* | output |
* | --- |
* | "Data sources" |
*
* @param {Page_Title_DatasourcesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_datasources = /** @type {((inputs?: Page_Title_DatasourcesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_DatasourcesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_datasources(inputs)
	return en_page_title_datasources(inputs)
});